import { Reducer, Action } from "redux";

import { AuctionTypes } from "./auctions.types";
import { Auction } from "../../models/auction.types";
import dayjs from "dayjs";

const INITIAL_STATE: Auction = {
  socket: null,
  selectedVarieties: [],
  selectedHubs: [],
  selectedClaims: [],
  startDate: dayjs().format("YYYY-MM-DD"),
  endDate: dayjs().format("YYYY-MM-DD"),
  auctionCount: [],
  activeData: [],
  upcomingData: [],
  bidsData: [],
  winsData: [],
  reportData: [],
};

const auctionReducer: Reducer<Auction, Action> = (
  state = INITIAL_STATE,
  action: any
) => {
  switch (action.type) {
    case AuctionTypes.SET_SELECTED_VARIETIES:
      return {
        ...state,
        selectedVarieties: action.payload,
      };
    case AuctionTypes.SET_SELECTED_HUBS:
      return {
        ...state,
        selectedHubs: action.payload,
      };
    case AuctionTypes.SET_SELECTED_CROP:
      return {
        ...state,
        selectedCrop: action.payload,
      };
    case AuctionTypes.SET_SELECTED_CLAIMS:
      return {
        ...state,
        selectedClaims: action.payload,
      };
    case AuctionTypes.SET_START_DATE:
      return {
        ...state,
        startDate: action.payload,
      };
    case AuctionTypes.SET_END_DATE:
      return {
        ...state,
        endDate: action.payload,
      };
    case AuctionTypes.SET_ACTIVE_AUCTION:
      return {
        ...state,
        activeData: action.payload,
      };
    case AuctionTypes.SET_UPCOMING_AUCTION:
      return {
        ...state,
        upcomingData: action.payload,
      };
    case AuctionTypes.SET_BIDS_EVENT:
      return {
        ...state,
        bidsData: action.payload,
      };
    case AuctionTypes.SET_WINS_EVENT:
      return {
        ...state,
        winsData: action.payload,
      };
    case AuctionTypes.SET_REPORT_EVENT:
      return {
        ...state,
        reportData: action.payload,
      };
    case AuctionTypes.SET_COUNT_EVENT:
      return {
        ...state,
        auctionCount: action.payload,
      };
    case AuctionTypes.SET_SOCKET:
      return {
        ...state,
        socket: action.payload,
      };
    case AuctionTypes.RESET_AUCTION_DATA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default auctionReducer;
